import { createContext, useState, ReactNode, useEffect, useContext } from "react";
import { UserType } from "../data/User";


// Defina o tipo do contexto
interface AuthContextType {
  user: UserType | null;
  setUser: (user: UserType | null) => void;
}

// Criar o contexto com um valor padrão que nunca será null para os consumidores.
// A verificação será feita no hook customizado.
export const AuthContext = createContext<AuthContextType>({
  user: null,
  setUser: () => {},
});

// Hook customizado para consumir o contexto
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }: {children: ReactNode}) => {
  const [user, setUser] = useState<UserType | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser) as UserType;
        setUser(parsedUser);        
      } catch (error) {
        console.error("Failed to parse user from localStorage", error);
        localStorage.removeItem('user');
      }
    }

    setLoading(false);
  }, []);

  // Função para atualizar o estado e o localStorage
  const handleSetUser = (user: UserType | null) => {
    setUser(user);
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  };

  if(loading){
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ user, setUser: handleSetUser }}>
      {children}
    </AuthContext.Provider>
  );
}